import React from 'react';
import PropTypes from 'prop-types';
import { SecondaryActionButton, Stack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';

const Layout = ({
  onAdd,
}) => {
  const { resource } = useMetaLayoutContext();
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <MetaFormFields
        resource={resource}
      />
      <SecondaryActionButton
        icon="add"
        iconPosition="start"
        label="Add"
        onClick={() => onAdd(resource)}
        size="md"
        disabled={!resource.isValid()}
      />
    </Stack>
  );
};

Layout.propTypes = {
  onAdd: PropTypes.func.isRequired,
};

export default Layout;
